import { logger } from '@superbet-group/web.lib.utilities';

import {
    ComtradeWelcomeBonus,
    WelcomeBonusKind,
} from '@core/models/bonus/WelcomeBonus';
import { WelcomeOfferBonusType } from '@core/models/bonus/WelcomeOfferBonusType';
import { WelcomeOfferBonusTypeDto } from '@core/models/bonus/WelcomeOfferBonusTypeDto';

import { ComtradeWelcomeBonusDto } from './dtos/WelcomeBonusDto';

export function transformComtradeWelcomeBonus(dto: ComtradeWelcomeBonusDto): ComtradeWelcomeBonus {
    return {
        kind: WelcomeBonusKind.Comtrade,
        id: dto.id,
        title: getTitle(dto.type),
        description: dto.description,
        image: dto.image,
        type: getWelcomeBonusType(dto.type),
        code: dto.code,
        staticUrl: dto.staticUrl,
    };
}

function getTitle(typeDto: WelcomeOfferBonusTypeDto) : WelcomeOfferBonusType {
    const title = titleMapping[typeDto];
    if (!title) {
        logger.error(new Error(`Undefined title for welcome bonus type: ${typeDto}`));
    }
    return title;
}

function getWelcomeBonusType(typeDto: WelcomeOfferBonusTypeDto) : WelcomeOfferBonusType {
    const type = typeMappings[typeDto];
    if (!type) {
        logger.error(new Error(`Undefined type for welcome bonus type: ${typeDto}`));
    }
    return type;
}

const titleMapping: Record<WelcomeOfferBonusTypeDto, string> = {
    [WelcomeOfferBonusTypeDto.Sport]: 'bonus.welcome_offer.sport_bonus_title',
    [WelcomeOfferBonusTypeDto.Casino]: 'bonus.welcome_offer.casino_bonus_title',
};

const typeMappings: Record<WelcomeOfferBonusTypeDto, WelcomeOfferBonusType> = {
    [WelcomeOfferBonusTypeDto.Sport]: WelcomeOfferBonusType.Sport,
    [WelcomeOfferBonusTypeDto.Casino]: WelcomeOfferBonusType.Casino,
};
